<script lang="ts">
  import { onMount, onDestroy } from "svelte";

  const syncTime = () => {
    if (document?.hidden) return;
    ssGoes = new Date(Date.now());
  };

  let { ssGoes = $bindable(new Date(Date.now())) } = $props();
  let timeGoes: ReturnType<typeof setInterval> | undefined = $state();

  onMount(() => {
    timeGoes = setInterval(() => {
      ssGoes = new Date(Date.now());
    }, 1000);
  });

  onDestroy(() => {
    if (timeGoes) clearInterval(timeGoes);
  });
</script>

<svelte:document onvisibilitychange={syncTime} />
